//公用弹窗
import { ElMessage } from 'element-plus'

export default function tips(code,message){
	console.log(code,message)
	if(code == 200){
		ElMessage({
		    message: message,
		    type: "success",
		  })
	}else{
		ElMessage({
		    message: message,
		    type: "error",
		  })
	}
	
}